<template>
	<div id="wrapper">
		<RTHeader :title="title"/>
    <RTNavigation/>
		<div id="main">
			<div class="inner">
        <header>
			<p><router-link to="/" class="body-2 font-weight-bold">zurück zur Übersicht</router-link></p>
        </header>
		<p>
			<!--Das Tabler & Ladies - Universum ist groß, wenn nicht sogar grenzenlos!-->
			<br>Diese Seite verschafft Dir eine Übersicht über Unternehmen von Ladies & Tablern, die eigene Produkte sowie Dienstleistungen anbieten, um Direktkäufe ohne Umwege zu vereinfachen.
			<br>Für eine gegenseitige Unterstützung, bauchen wir auch DICH. Teile diese Seite oder nutze unseren <a href="#" @click.prevent='showPressModal'>Pressetext</a>. Andere Ladies & Tabler werden es Dir danken.
		</p>
		<div class="row">
			<!--
			<div class=" b-1 col-12">
				Du bist vom Round Table | Ladies Circle | Old Tablers | Tangent Club und möchtest in diese Übersicht mit aufgenommen werden, dann kannst du dich <router-link to="/eintragen" class="body-2 font-weight-bold primary-color">HIER</router-link> eintragen.
			</div>
			-->
			<div class="mt-1 pb-1 col-8 col-12-xsmall">
				Möchtest du darüber hinaus die Weiterentwicklung dieser Seite sichern, dann unterstütze den Betrieb durch einen Klick auf "Buy me a coffee". Jeglicher Überschuss kommt aktuell meinem Herzensprojekt <a class="primary-color" href="https://www.radzelten.de/" target="_blank"> "Music for Karakul"</a> zu Gute.
			</div>
			<div class="pt-05 mt-1 col-4 col-12-xsmall">
				<a class="no-deco" href="https://www.buymeacoffee.com/TobiasHubold" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/default-orange.png" alt="Buy Me A Coffee" style="height: 45px !important;width: 200px !important;" ></a>
			</div>
		</div>

      </div>
	</div>

    <!-- Footer -->
    <RTFooter></RTFooter>

	<!-- Modals -->
	<RTmodal ref="pressModal" :clickAndClose="false">
		<div class="inner">
			<RTpress/>
		</div>
	</RTmodal>
  </div>
</template>

<script>
import RTHeader from '@/components/RTHeader.vue'
import RTNavigation from '@/components/RTNavigation.vue'
import RTpress from '@/components/RTpress.vue'
import RTmodal from '@/components/RTmodal.vue'
import RTFooter from '@/components/RTFooter.vue'
  export default {
    name: 'AboutView',
    components: {
		RTHeader,
		RTNavigation,
		RTpress,
		RTmodal,
		RTFooter,
	},
	data(){
		return {
			title:"Unternehmen von Ladies & Tablern",
		}
  },
  methods:{
	showPressModal() {
		this.$refs.pressModal.show();
	}
  },
  beforeRouteEnter: (to,from,next) => {
		next(() => {
		setTimeout(()=>{
				window.scrollTo(0, 0);
			},300);
		});
	},
  }
</script>

<style scoped>

</style>
